import { useEffect, useRef } from "react"
import { insertImage$, usePublisher } from "@mdxeditor/editor"

import resizeImageWithDataUrl from "utils/resizeImageWithDataUrl"

const CustomImageUpload = () => {
  const fileInputRef = useRef<HTMLInputElement | null>(null)
  const insertImage = usePublisher(insertImage$)

  const handleImageButtonClick = (e: Event) => {
    e.preventDefault()
    e.stopPropagation()

    const input = document.createElement("input")
    input.type = "file"
    input.accept = "image/*"
    input.style.display = "none"
    input.multiple = false

    input.onchange = event => {
      const target = event.target as HTMLInputElement
      if (target.files && target.files.length > 0) {
        const file = target.files[0]

        const reader = new FileReader()

        reader.onload = e => {
          resizeImageWithDataUrl({
            dataUrl: e.target?.result as string,
            keepRatio: true,
          }).then((resizedBase64: string) => {
            insertImage({ src: resizedBase64 })
          })
        }

        reader.readAsDataURL(file)
      }
    }

    fileInputRef.current = input
    document.body.appendChild(input)

    if (fileInputRef.current) {
      fileInputRef.current.click()
      document.body.removeChild(input)
    }
  }

  useEffect(() => {
    // This hack is used to override the default behavior of the InsertImage button
    const buttons = document.querySelectorAll(".mdxeditor-toolbar button")
    const imageButton = buttons[buttons.length - 1]

    imageButton.addEventListener("click", handleImageButtonClick, true)

    return () => {
      imageButton.removeEventListener("click", handleImageButtonClick, true)
    }
  }, [])

  return null
}

export default CustomImageUpload
